/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bodymap_Intensity_LabelInputs */

const en_us2_bodymap_intensity_label = /** @type {(inputs: Bodymap_Intensity_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How strong is it, 1 to 10?`)
};

const pt_br2_bodymap_intensity_label = /** @type {(inputs: Bodymap_Intensity_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual a intensidade, de 1 a 10?`)
};

const es_419_bodymap_intensity_label = /** @type {(inputs: Bodymap_Intensity_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué tan fuerte es, del 1 al 10?`)
};

const pt_pt2_bodymap_intensity_label = /** @type {(inputs: Bodymap_Intensity_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual a intensidade, de 1 a 10?`)
};

const fr_fr2_bodymap_intensity_label = /** @type {(inputs: Bodymap_Intensity_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelle intensité, de 1 à 10 ?`)
};

const de_de2_bodymap_intensity_label = /** @type {(inputs: Bodymap_Intensity_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie stark, von 1 bis 10?`)
};

const it_it2_bodymap_intensity_label = /** @type {(inputs: Bodymap_Intensity_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto è forte, da 1 a 10?`)
};

/**
* | output |
* | --- |
* | "How strong is it, 1 to 10?" |
*
* @param {Bodymap_Intensity_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const bodymap_intensity_label = /** @type {((inputs?: Bodymap_Intensity_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bodymap_Intensity_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_bodymap_intensity_label(inputs)
	if (locale === "es-419") return es_419_bodymap_intensity_label(inputs)
	if (locale === "pt-PT") return pt_pt2_bodymap_intensity_label(inputs)
	if (locale === "fr-FR") return fr_fr2_bodymap_intensity_label(inputs)
	if (locale === "de-DE") return de_de2_bodymap_intensity_label(inputs)
	if (locale === "it-IT") return it_it2_bodymap_intensity_label(inputs)
	return en_us2_bodymap_intensity_label(inputs)
});
export { bodymap_intensity_label as "bodymap.intensity.label" }